<mat-sidenav-container dir="{{direction}}">
  <mat-sidenav #sidenav role="navigation">
    <div fxLayout="column" fxLayoutGap="32px" fxLayoutAlign="space-between center" class="nav-list-wrapper">
      <mat-nav-list *ngIf="routes && routes.length>0">
        <ng-container *ngFor="let route of routes">
          <a mat-list-item (click)="navClickListener(route)" [routerLink]="route.children ? null : '/'+route.path"
            class="nav-item">
            <span fxFlex fxLayout="row">
              <i class="fas primary-color" [class]="route.data.icon"></i>
              <div class="label">{{route.data.title | translate}}</div>
            </span>
            <i class="fas primary-color" *ngIf="route.children"
              [class]="route.data.isExpanded ? 'fa-chevron-down' : (direction === 'ltr' ? 'fa-chevron-right' : 'fa-chevron-left')"></i>
          </a>

          <div *ngIf="route.children?.length && route.data.isExpanded" class="child-wrapper">
            <a mat-list-item *ngFor="let child of route.children" (click)="navClickListener(child)"
              [routerLink]="'/' + route.path + '/' + child.path" class="nav-item child-nav-item">
              <i class="fas accent-color" [class]="child.data.icon"></i>
              <div class="label">{{child.data.title | translate}}</div>
            </a>
          </div>
        </ng-container>
      </mat-nav-list>
      <div class="bold text-center font-size-three-quarters">{{version}}</div>
    </div>
  </mat-sidenav>
  <mat-sidenav-content>
    <div *ngIf="loadingWebsite" fxLayout="column" fxLayoutGap="16px" fxLayoutAlign="center center"
      class="loading-website">
      <div>
        <img src="./assets/logo-full-size.png" class="logo" />
      </div>
      <div>
        <mat-spinner [diameter]="50"></mat-spinner>
      </div>
    </div>
    <main *ngIf="!loadingWebsite">
      <ngx-loading-bar [includeSpinner]="false"></ngx-loading-bar>
      <app-header [sidenav]="sidenav"></app-header>
      <div class="router-container padding-2">
        <!-- <div class="card margin-b-1">
          <div *ngIf="pageTitle.length" class="font-size-one">
            <span>
              <a style="text-decoration: none;color: gray;" *ngFor="let link of pageTitle">
                {{link.value | translate}} {{link.isClickable?' / ':''}}
              </a>
            </span>
          </div>
        </div> -->

        <router-outlet></router-outlet>
      </div>
      <app-footer></app-footer>
    </main>
  </mat-sidenav-content>
</mat-sidenav-container>